var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-bottom-btn",style:(_vm.buttonStyle),on:{"click":_vm.handleClick}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z","fill":"currentColor"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }